<script>
import api from '@utils/api'

export default {
  name: 'FinalizeDocument',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    documentId: {
      type: Number,
      default: 0,
    },
    specs: {
      type: Array,
      default: () => [],
    },
    hasChanges: {
      type: Boolean,
      default: false,
    },
    saveChangesHandler: {
      type: Function,
      default: null,
    },
    discardChangesHandler: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      needConfirm: false,
      serials: null,
    }
  },
  computed: {
    hasPDO() {
      if (this.$route.params.documentType !== 'returns') return false
      const goods = this.$store.getters['data/getDictionary']('goods')
      for (const item of this.specs) {
        const goodsItem = goods.find(elem => elem.id === item.goods)
        if (goodsItem.group === 5) return true
      }
      return false
    },
  },
  methods: {
    submit() {
      this.loading = true
      if (this.hasChanges && this.saveChangesHandler) {
        this.saveChangesHandler().then(() => this.finalizeDocument())
      } else {
        this.finalizeDocument()
      }
    },
    discardChangesAndSubmit() {
      this.loading = true
      this.discardChangesHandler().then(() => this.finalizeDocument())
    },
    finalizeDocument() {
      api
        .finalizeDocumentNoErrorHandler(this.documentId, this.needConfirm)
        .then(() => {
          this.$emit('close-finalize-modal')
          this.loading = false
          this.$router.go(-1)
        })
        .catch(error => {
          try {
            const responseCode = error.response.data.code
            if (responseCode === '8') {
              // Need to confirm finalization
              this.needConfirm = true
              this.serials = this.extractSerials(error.response.data.message)
            } else {
              api.handleError(error)
              this.$emit('close-finalize-modal')
            }
            this.loading = false
          } catch (e) {}
        })
    },
    extractSerials(errorMessage) {
      let indexStart = errorMessage.indexOf('[')
      let indexStop = errorMessage.indexOf(']')
      let serialsStr = errorMessage.substring(indexStart + 1, indexStop)

      return serialsStr.split(',')
    },
  },
}
</script>

<template>
  <v-dialog
    :max-width="hasChanges|| needConfirm ? '750' : '355'"
    v-model="dialog"
    persistent
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__finalize_document') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text
        v-if="hasPDO"
        class="text-xs-center"
      >
        <p>{{ $t('message__returns_finalizing') }}</p>
      </v-card-text>
      <v-card-text v-if="needConfirm">
        <div style="font-weight: bolder; margin-bottom: 8px">{{
        $t('message__plugs_are_not_initialized') }}
          <div
            v-for="(serial, index) in serials"
            :key="serial">
            {{ serial + ( index === serials.length -1 ? "" : ",") }}
          </div>
        </div>
        <div :class="$style.finalizeAlign">{{ $t('message__confirm_finalization') }}</div>
      </v-card-text>
      <v-card-text
        v-if="hasChanges && !needConfirm"
        :class="$style.finalizeAlign">
        {{ $t('message__finalize_with_changes') }}
      </v-card-text>
      <v-card-actions v-if="hasChanges">
        <v-layout
          row
          wrap>
          <v-spacer />
          <v-flex>
            <v-btn
              :disabled="loading"
              color="secondary"
              @click="$emit('close-finalize-modal')">{{ $t('buttons__close') }}</v-btn>
            <v-btn
              :disabled="loading"
              :loading="loading"
              color="secondary"
              @click="discardChangesAndSubmit">{{ $t('buttons__discard_changes_and_save') }}</v-btn>
            <v-btn
              :disabled="loading"
              :loading="loading"
              :color="needConfirm ? 'warning' : 'success'"
              @click="submit">{{ $t('buttons__save_changes') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="$emit('close-finalize-modal')">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          :color="needConfirm ? 'warning' : 'success'"
          @click="submit">{{ $t('buttons__finalize') }}</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.finalizeAlign {
  text-align: left !important;
  white-space: pre-line;
}
</style>
